import React from 'react';

import SingleNextButton from '../Atoms/SingleNextButton';
import StepShell from '../StepComponents/StepShell';
import Form from '../StepComponents/Form';
import { getApp, setApp } from '../../index';

class StepDisclosures extends React.Component {
    render() {

        var agreementPDF = "https://vantagewest.org/themencode-pdf-viewer-sc/?tnc_pvfw=ZmlsZT1odHRwczovL3ZhbnRhZ2V3ZXN0Lm9yZy9maWxlcy8yMDE4LzExL05FVy1Db25uZWN0VmlzYS1Db25uZWN0LVNpZ25hdHVyZS1BZ3JlZW1lbnQucGRmJnNldHRpbmdzPSZsYW5nPWVuLVVT#page=&zoom=auto&pagemode=&ver=" + Math.floor((Math.random() * 100) + 1);
        var solicitationPDF = "https://vantagewest.org/themencode-pdf-viewer/?file=https://vantagewest.org/files/2022/09/Visa-Solicitation.pdf#page=&zoom=auto&pagemode=&ver=" + Math.floor((Math.random() * 100) + 1);

        if (getApp('blockPromo') === false) {
            if (getApp('promoCode')) {
                solicitationPDF = "https://vantagewest.org/themencode-pdf-viewer/?file=https://vantagewest.org/files/2021/11/2percent-Credit-Card-Solicitation.pdf#page=&zoom=auto&pagemode=&ver="+ Math.floor((Math.random() * 100) + 1);
            }
        }

        var backLink;
        var btCount = getApp('balanceTransferArray').length;
        var bt = getApp('balanceTransfer');

        if (btCount > 0 && bt === 'yes') {
            backLink = '/loan-application/balance-transfer-detail';
        } else if (btCount === 0 && bt === 'no') {
            backLink = '/loan-application/balance-transfer';
        }

        return (
            <StepShell stepID="StepDisclosures"
                friendlyText="Almost done! Please read these documents."
                requestText="By checking the boxes below, you acknowledge you have read and you accept the terms of the disclosures."
                progress="90%"
                progressLabel="Disclosures"
                backLink={backLink}
            >
                <div className="custom-cc">
                    <Form nextLink="/loan-application/final-review">
                        <CheckBoxDisclosure name="applicationDisclosure" label="Credit Card Agreement Viewed" url={agreementPDF} linkText="Application Disclosure PDF" />
                        <CheckBoxDisclosure name="solicitationDisclosure" label="Application and Solicitation Disclosure Viewed" url={solicitationPDF} linkText="Solicitation Disclosure PDF" />
                        <SingleNextButton nextBtnTxt="next" />
                    </Form>
                </div>
            </StepShell>
        )
    }
}

class CheckBoxDisclosure extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
            viewed: "unviewed",
            checked: getApp(this.props.name),
            modal: false,
            viewWarning: false
        };

        disclosureBlocker = disclosureBlocker.bind(this);
    }

    pdfClicked(event) {

        event.preventDefault();

        const thisWarning = this;
        
        setTimeout( function() {
            thisWarning.setState({
                viewed: "viewed",
                checked: true
            }, function(){
                setApp(this.props.name, true);
                disclosureBlocker();
            });
        }, 3000);

        this.setState({
            modal: true
        });
        //this.state.modal = true;
        
        setTimeout( function() {
            thisWarning.state.viewWarning = false;
        }, 100);
    }

    closeModal() {
        this.setState({modal: false});
    }

    checkboxCheck(event) {
        this.setState({viewed: "viewed"}, function(){
            var globalVal = getApp(this.props.name);
            setApp(this.props.name, !globalVal);
            this.setState({
                checked: !globalVal
            });
            //this.state.checked = !globalVal;
            disclosureBlocker();
        });
    }

    falseClick(event) {
        if(this.state.viewed === "unviewed") {
            this.setState({viewWarning: true});
        }
    }

    render() {
        const modalCheck = this.state.modal;
        const viewWarningCheck = this.state.viewWarning;

        var modalHTML = (
            <div className="modal-disclosure">
                <span className="iframe-closer" onClick={this.closeModal.bind(this)}>×</span>
                <span className="modal-disclosure-darkening" onClick={this.closeModal.bind(this)}></span>
                <div className="disclosure-iframe-wrapper">
                    <iframe className="disclosure-iframe" src={this.props.url}></iframe>
                </div>
            </div>  
        );

        return ( 
            <div className={`loanApp-disclosure-checkbox-wrap ${this.state.viewed}`} onClick={this.falseClick.bind(this)} >
                <input type="checkbox" name={this.props.name} checked={this.state.checked} className="pull-left loanApp-form-control" onChange={this.checkboxCheck.bind(this)} />
                <label htmlFor={this.props.name}>{this.props.label}</label>
                {modalCheck ? modalHTML : ""}
                <a href="{this.props.url}" className="application-disclosure" target="_blank" onClick={this.pdfClicked.bind(this)}>{this.props.linkText}</a>
                <div className="hug" style={{color: "red", fontSize: ".75em", fontWeight: "bold"}} >{viewWarningCheck ? "You will need to read the disclosure in order to continue." : ""}</div>
            </div>
        );
    }
}

function disclosureBlocker(){

    var app = getApp('applicationDisclosure');
    var sol = getApp('solicitationDisclosure');

    if( app && sol ){
        setApp('blockDisclosures', false);
    }else{
        setApp('blockDisclosures', true);
    }
}

export default StepDisclosures;